// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sovI","label":"styles_label__3tBEK"};